module.exports = __webpack_public_path__ + "static/media/2d2.01e0be85.jpg";